module.exports = __webpack_public_path__ + "static/media/dork2.bf01b1b7.png";